import { Input, notification } from 'antd';
import { Field, Form, Formik } from 'formik';
import React from 'react';
import FormItem from '../../components/FormItem';
import Modal from '../../components/Modal';
import { Option, Select } from '../../components/Select';
import UploadFile from '../../components/UploadFile';
import { useServices } from '../../core/services/useServices';
import { getAdditionInfo } from '../../section/Common/utils/getAdditionInfo';
import { required } from '../../utils/validation';
import { feedbackOptions } from '../../core/constants/global-constants';

const { TextArea } = Input;

const FeedbackImprovement = ({ onClose, open, user }) => {
  const { user: { feedback } } = useServices();
  const [charCount, setCharCount] = React.useState(0);
  const textAreaMaxLength = 1500;

  const onLeaveFeedback = async (data, { setSubmitting }) => {
    const userInfo = getAdditionInfo(user?.id);
    try {
      const res = await feedback({ ...data || {}, ...userInfo }, 'improvement');

      if (res?.success) {
        notification?.success({
          description: 'Successfully sent',
          message: res?.data.msg
        });
      }
    } catch (e) {
      console.log(e);
    }
    setSubmitting(false);
    onClose();
  };

  return (
    <Formik
      initialValues={{
        page_or_functionality: null,
        details: null,
        files: []
      }}
      enableReinitialize
      onSubmit={onLeaveFeedback}
    >
      {({ errors, handleSubmit, isSubmitting, dirty }) => (
        <Form>
          <Modal okText='Submit'
            title='Improvement'
            visible={open}
            onOk={handleSubmit}
            okButtonProps={{ disabled: isSubmitting || Boolean(Object.values(errors)?.length) || !dirty }}
            onCancel={onClose}
          >
            <FormItem label='Affected Page or Functionality' required error={errors?.page_or_functionality}>
              <Field name={'page_or_functionality'} validate={required}>
                {({ field: { value, ...rest }, form: { setFieldValue } }) => (
                  <Select
                    placeholder='Select...'
                    value={value === '' || value === null ? undefined : value}
                    {...rest}
                    onChange={v => {
                      setFieldValue('page_or_functionality', v);
                    }}
                  >
                    {feedbackOptions.map((role) => (
                      <Option key={role} value={role}>
                        {role}
                      </Option>
                    ))}
                  </Select>
                )}
              </Field>
            </FormItem>
            <FormItem label='Describe the requested improvement' required error={errors?.details}>
              <Field name={'details'} validate={required}>
                {({ field: { value, onChange, ...rest }, form: { setFieldValue } }: any) => (
                  <><TextArea
                    autoSize={{ minRows: 2, maxRows: 4 }}
                    value={value}
                    placeholder=''
                    maxLength={textAreaMaxLength}
                    onChange={event => {
                      onChange(event);
                      setFieldValue('details', event.target.value.replace(/\n$/, ''));
                      setCharCount(event.target.value.length);
                    }}
                    {...rest} />
                  <span style={{ textAlign: 'right',
                    fontStyle: 'italic',
                    fontSize: 'smaller',
                    display: 'block' }}>
                    {textAreaMaxLength - charCount} characters left</span></>
                )}
              </Field>
            </FormItem>
            <UploadFile
              name='files'
            />
          </Modal>
        </Form>)}
    </Formik>
  );
};

export default FeedbackImprovement;